export default function useSnapState() {
    var snapClasses = [
        'snap-y',
        'snap-mandatory',
        'overflow-y-auto',
        'h-screen',
    ];
    var snapContainerElement = document.getElementById('container-snap-scroller');
    var isSnapContainerExist = snapContainerElement !== undefined ||
        (snapContainerElement !== null && snapContainerElement instanceof Element);
    if (!isSnapContainerExist) {
        return false;
    }
    var isContainerWithSnap = snapClasses
        .map(function (className) {
        return ((snapContainerElement === null || snapContainerElement === void 0 ? void 0 : snapContainerElement.classList.contains(className)) ||
            (snapContainerElement === null || snapContainerElement === void 0 ? void 0 : snapContainerElement.classList.contains('lg:' + className)));
    })
        .every(function (booleanResult) { return booleanResult; });
    return isContainerWithSnap;
}
